(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-slider"]) return;
  try {
    
  
 window.addEventListener('load', function() {
      var swiperHof = new Swiper(".bestsellers-slider .swiper", {
       effect: "coverflow",
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: "auto",
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         modifier: 1,
         slideShadows: true,
       },
       pagination: {
         el: ".swiper-pagination",
       },
     });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blantons-landing"]) return;
  try {
    
    const sliderEl = document.querySelector('.triple-slider');
    createTripleSlider(sliderEl);

    // eslint-disable-next-line

  function createTripleSlider(el) {
    // main swiper el
    const swiperEl = el.querySelector('.swiperBlantonsSliderSnippet');

    // create prev duplicate swiper
    const swiperPrevEl = swiperEl.cloneNode(true);
    swiperPrevEl.classList.add('triple-slider-prev');
    el.insertBefore(swiperPrevEl, swiperEl);
    const swiperPrevSlides = swiperPrevEl.querySelectorAll('.swiper-slide');
    const swiperPrevLastSlideEl = swiperPrevSlides[swiperPrevSlides.length - 1];
    swiperPrevEl
      .querySelector('.swiper-wrapper')
      .insertBefore(swiperPrevLastSlideEl, swiperPrevSlides[0]);

    // create next duplicate swiper
    const swiperNextEl = swiperEl.cloneNode(true);
    swiperNextEl.classList.add('triple-slider-next');
    el.appendChild(swiperNextEl);
    const swiperNextSlides = swiperNextEl.querySelectorAll('.swiper-slide');
    const swiperNextFirstSlideEl = swiperNextSlides[0];
    swiperNextEl
      .querySelector('.swiper-wrapper')
      .appendChild(swiperNextFirstSlideEl);

    // Add "main" class
    swiperEl.classList.add('triple-slider-main');

    // common params for all swipers
    const commonParams = {

      speed: 600,
      loop: true,
      parallax: true,
    };

    let tripleMainSwiper;

    // init prev swiper
    const triplePrevSwiper = new Swiper(swiperPrevEl, {
      ...commonParams,
      allowTouchMove: false,
      on: {
        click() {
          tripleMainSwiper.slidePrev();
        },
      },
    });
    // init next swiper
    const tripleNextSwiper = new Swiper(swiperNextEl, {
      ...commonParams,
      allowTouchMove: false,
      on: {
        click() {
          tripleMainSwiper.slideNext();
        },
      },
    });
    // init main swiper
    tripleMainSwiper = new Swiper(swiperEl, {
      ...commonParams,
      grabCursor: true,
      controller: {
        control: [triplePrevSwiper, tripleNextSwiper],
      },
      on: {
        destroy() {
          // destroy side swipers on main swiper destroy
          triplePrevSwiper.destroy();
          tripleNextSwiper.destroy();
        },
      },

       pagination: {
          el: '.swiper-pagination',
          clickable:true
        }
    });

    return tripleMainSwiper;
  }



  window.addEventListener('load', function () {
  const swiper = new Swiper('.newarrivals-slider .swiper', {
  // pass Panorama module
  modules: [EffectPanorama],
  // enable "panorama" effect
  effect: 'panorama',
  slidesPerView: 1.5,
  loop: true,
  loopAdditionalSlides: 1,
  centeredSlides: true,
  grabCursor: true,
  // panorama effect parameters
  panoramaEffect: {
    depth: 150,
    rotate: 45,
  },
  breakpoints: {
    480: {
      slidesPerView: 2,
      panoramaEffect: {
        rotate: 35,
        depth: 150,
      },
    },
    640: {
      slidesPerView: 3,
      panoramaEffect: {
        rotate: 30,
        depth: 150,
      },
    },
    1024: {
      slidesPerView: 4,
      panoramaEffect: {
        rotate: 30,
        depth: 200,
      },
    },
    1200: {
      slidesPerView: 4,
      panoramaEffect: {
        rotate: 25,
        depth: 250,
      },
    },
  },
});

});



!function(e,a){"object"==typeof exports&&"undefined"!=typeof module?module.exports=a():"function"==typeof define&&define.amd?define(a):(e="undefined"!=typeof globalThis?globalThis:e||self).EffectPanorama=a()}(this,(function(){"use strict";return"undefined"!=typeof window&&window.SwiperElementRegisterParams&&window.SwiperElementRegisterParams(["panoramaEffect"]),function({swiper:e,extendParams:a,on:s}){a({panoramaEffect:{depth:200,rotate:30}}),s("beforeInit",(()=>{if("panorama"!==e.params.effect)return;e.classNames.push(`${e.params.containerModifierClass}panorama`),e.classNames.push(`${e.params.containerModifierClass}3d`);const a={watchSlidesProgress:!0};Object.assign(e.params,a),Object.assign(e.originalParams,a)})),s("progress",(()=>{if("panorama"!==e.params.effect)return;const a=e.slidesSizesGrid,{depth:s=200,rotate:t=30}=e.params.panoramaEffect,r=t*Math.PI/180/2,n=1/(180/t);for(let i=0;i<e.slides.length;i+=1){const o=e.slides[i],f=o.progress,p=a[i],d=f+(e.params.centeredSlides?0:.5*(e.params.slidesPerView-1)),m=1-Math.cos(d*n*Math.PI),l=d*(p/3)*m+"px",c=d*t,u=.5*p/Math.sin(r)*m-s+"px";o.style.transform="horizontal"===e.params.direction?`translateX(${l}) translateZ(${u}) rotateY(${c}deg)`:`translateY(${l}) translateZ(${u}) rotateX(${-c}deg)`}})),s("setTransition",((a,s)=>{"panorama"===e.params.effect&&e.slides.forEach((e=>{e.style.transitionDuration=`${s}ms`}))}))}}));
//# sourceMappingURL=effect-panorama.min.js.map

  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.EffectPanorama = factory());
})(this, (function () { 'use strict';

  if (typeof window !== 'undefined' && window.SwiperElementRegisterParams) {
    window.SwiperElementRegisterParams(['panoramaEffect']);
  }

  function EffectPanorama({ swiper, extendParams, on }) {
    extendParams({
      panoramaEffect: {
        depth: 200,
        rotate: 30,
      },
    });

    on('beforeInit', () => {
      if (swiper.params.effect !== 'panorama') return;
      swiper.classNames.push(`${swiper.params.containerModifierClass}panorama`);
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
      const overwriteParams = {
        watchSlidesProgress: true,
      };
      Object.assign(swiper.params, overwriteParams);
      Object.assign(swiper.originalParams, overwriteParams);
    });

    on('progress', () => {
      if (swiper.params.effect !== 'panorama') return;
      const sizesGrid = swiper.slidesSizesGrid;
      const { depth = 200, rotate = 30 } = swiper.params.panoramaEffect;
      const angleRad = (rotate * Math.PI) / 180;
      const halfAngleRad = angleRad / 2;
      const angleModifier = 1 / (180 / rotate);

      for (let i = 0; i < swiper.slides.length; i += 1) {
        const slideEl = swiper.slides[i];
        const slideProgress = slideEl.progress;
        const slideSize = sizesGrid[i];
        const progressModifier = swiper.params.centeredSlides
          ? 0
          : (swiper.params.slidesPerView - 1) * 0.5;
        const modifiedProgress = slideProgress + progressModifier;
        const angleCos = 1 - Math.cos(modifiedProgress * angleModifier * Math.PI);
        const translateX = `${modifiedProgress * (slideSize / 3) * angleCos}px`;
        const rotateY = modifiedProgress * rotate;
        const radius = (slideSize * 0.5) / Math.sin(halfAngleRad);
        const translateZ = `${radius * angleCos - depth}px`;
        slideEl.style.transform =
          swiper.params.direction === 'horizontal'
            ? `translateX(${translateX}) translateZ(${translateZ}) rotateY(${rotateY}deg)`
            : `translateY(${translateX}) translateZ(${translateZ}) rotateX(${-rotateY}deg)`;
      }
    });

    on('setTransition', (s, duration) => {
      if (swiper.params.effect !== 'panorama') return;
      swiper.slides.forEach((slideEl) => {
        // eslint-disable-next-line
        slideEl.style.transitionDuration = `${duration}ms`;
      });
    });
  }

  return EffectPanorama;

}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blantons-slider"]) return;
  try {
    
    const sliderEl = document.querySelector('.triple-slider');
    createTripleSlider(sliderEl);

    // eslint-disable-next-line

  function createTripleSlider(el) {
    // main swiper el
    const swiperEl = el.querySelector('.swiperBlantonsSlider');

    // create prev duplicate swiper
    const swiperPrevEl = swiperEl.cloneNode(true);
    swiperPrevEl.classList.add('triple-slider-prev');
    el.insertBefore(swiperPrevEl, swiperEl);
    const swiperPrevSlides = swiperPrevEl.querySelectorAll('.swiper-slide');
    const swiperPrevLastSlideEl = swiperPrevSlides[swiperPrevSlides.length - 1];
    swiperPrevEl
      .querySelector('.swiper-wrapper')
      .insertBefore(swiperPrevLastSlideEl, swiperPrevSlides[0]);

    // create next duplicate swiper
    const swiperNextEl = swiperEl.cloneNode(true);
    swiperNextEl.classList.add('triple-slider-next');
    el.appendChild(swiperNextEl);
    const swiperNextSlides = swiperNextEl.querySelectorAll('.swiper-slide');
    const swiperNextFirstSlideEl = swiperNextSlides[0];
    swiperNextEl
      .querySelector('.swiper-wrapper')
      .appendChild(swiperNextFirstSlideEl);

    // Add "main" class
    swiperEl.classList.add('triple-slider-main');

    // common params for all swipers
    const commonParams = {

      speed: 600,
      loop: true,
      parallax: true,
    };

    let tripleMainSwiper;

    // init prev swiper
    const triplePrevSwiper = new Swiper(swiperPrevEl, {
      ...commonParams,
      allowTouchMove: false,
      on: {
        click() {
          tripleMainSwiper.slidePrev();
        },
      },
    });
    // init next swiper
    const tripleNextSwiper = new Swiper(swiperNextEl, {
      ...commonParams,
      allowTouchMove: false,
      on: {
        click() {
          tripleMainSwiper.slideNext();
        },
      },
    });
    // init main swiper
    tripleMainSwiper = new Swiper(swiperEl, {
      ...commonParams,
      grabCursor: true,
      controller: {
        control: [triplePrevSwiper, tripleNextSwiper],
      },
      on: {
        destroy() {
          // destroy side swipers on main swiper destroy
          triplePrevSwiper.destroy();
          tripleNextSwiper.destroy();
        },
      },

       pagination: {
          el: '.swiper-pagination',
          clickable:true
        }
    });

    return tripleMainSwiper;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["japanese-slider"]) return;
  try {
    
  window.addEventListener('load', function() {
      var swiperHof = new Swiper(".topjapanese-slider .swiper", {
       effect: "coverflow",
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: "auto",
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         modifier: 1,
         slideShadows: true,
       },
       pagination: {
         el: ".swiper-pagination",
       },
     });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"]) return;
  try {
    
  
 window.addEventListener('load', function() {
      var swiperHof = new Swiper(".newarrivals-slider .swiper", {
       effect: "coverflow",
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: "auto",
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         modifier: 1,
         slideShadows: true,
       },
       pagination: {
         el: ".swiper-pagination",
       },
     });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-picks"]) return;
  try {
    
  
 window.addEventListener('load', function() {
      var swiperHof = new Swiper(".rarepicks-slider .swiper", {
       effect: "coverflow",
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: "auto",
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         modifier: 1,
         slideShadows: true,
       },
       pagination: {
         el: ".swiper-pagination",
       },
     });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-picks-slider"]) return;
  try {
    
    const sliderEl = document.querySelector('.triple-slider-storepicks');
    createTripleSlider(sliderEl);

    // eslint-disable-next-line

  function createTripleSlider(el) {
    // main swiper el
    const swiperEl = el.querySelector('.swiperStorePicksSlider');

    // create prev duplicate swiper
    const swiperPrevEl = swiperEl.cloneNode(true);
    swiperPrevEl.classList.add('triple-slider-storepicks-prev');
    el.insertBefore(swiperPrevEl, swiperEl);
    const swiperPrevSlides = swiperPrevEl.querySelectorAll('.swiper-slide');
    const swiperPrevLastSlideEl = swiperPrevSlides[swiperPrevSlides.length - 1];
    swiperPrevEl
      .querySelector('.swiper-wrapper')
      .insertBefore(swiperPrevLastSlideEl, swiperPrevSlides[0]);

    // create next duplicate swiper
    const swiperNextEl = swiperEl.cloneNode(true);
    swiperNextEl.classList.add('triple-slider-storepicks-next');
    el.appendChild(swiperNextEl);
    const swiperNextSlides = swiperNextEl.querySelectorAll('.swiper-slide');
    const swiperNextFirstSlideEl = swiperNextSlides[0];
    swiperNextEl
      .querySelector('.swiper-wrapper')
      .appendChild(swiperNextFirstSlideEl);

    // Add "main" class
    swiperEl.classList.add('triple-slider-storepicks-main');

    // common params for all swipers
    const commonParams = {

      speed: 600,
      loop: true,
      parallax: true,
    };

    let tripleMainSwiper;

    // init prev swiper
    const triplePrevSwiper = new Swiper(swiperPrevEl, {
      ...commonParams,
      allowTouchMove: false,
      on: {
        click() {
          tripleMainSwiper.slidePrev();
        },
      },
    });
    // init next swiper
    const tripleNextSwiper = new Swiper(swiperNextEl, {
      ...commonParams,
      allowTouchMove: false,
      on: {
        click() {
          tripleMainSwiper.slideNext();
        },
      },
    });
    // init main swiper
    tripleMainSwiper = new Swiper(swiperEl, {
      ...commonParams,
      grabCursor: true,
      controller: {
        control: [triplePrevSwiper, tripleNextSwiper],
      },
      on: {
        destroy() {
          // destroy side swipers on main swiper destroy
          triplePrevSwiper.destroy();
          tripleNextSwiper.destroy();
        },
      },
    });

    return tripleMainSwiper;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-picks-slider"]) return;
  try {
    
  window.addEventListener('load', function() {
      var swiperHof = new Swiper(".topicks-slider .swiper", {
       effect: "coverflow",
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: "auto",
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         modifier: 1,
         slideShadows: true,
       },
       pagination: {
         el: ".swiper-pagination",
       },
     });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-scotches-slider"]) return;
  try {
    
  
window.addEventListener('load', function() {
      var swiperHof = new Swiper(".topscotches-slider .swiper", {
       effect: "coverflow",
       grabCursor: true,
       centeredSlides: true,
       slidesPerView: "auto",
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         modifier: 1,
         slideShadows: true,
       },
       pagination: {
         el: ".swiper-pagination",
       },
     });
  });

  } catch(e) { console.error(e); }
})();
})();
